// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"776d0bb0","453":"19be28b7","520":"e1b2607e","526":"47afe133"}[chunkId] + ".chunk.js";
};